export default __webpack_public_path__ + "media/zurb/img/events/wired/wired-thumb-e62b56e433f50fd4f00dbf2b5f207523.png";